import React from "react";

import * as Misc from "./../../../misc";

export default ({number, click, selected}) =>
  (
    <div className="confirmation-calendar-day-unit"
         onClick={e => Misc.ignore(e, () => click && click(number))}>
      <div className="confirmation-calendar-number">{number}</div>
      {selected ? <div className="confirmation-calendar-cursor"/> : null}
    </div>
  );




// WEBPACK FOOTER //
// ./src/components/common/calendar/dayView.js